/* Added the following code for POW-NOTIFY.Istiyak using AI Agent. April 5, 2026. Code Start */
/**
 * Header bell + popover listing notifications (REST + STOMP).
 * List shows subject + time only; full content opens in a dialog (email-style).
 */
import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Bell, Eye, CheckCheck, Trash2, Search } from 'lucide-react';
import moment from 'moment';
/* Added the following code for POW-938.Harsha using AI Agent. September 20, 2026. Code Start */
import { useNotificationsContext } from 'app/context/NotificationsContext';
/* Code end. Harsha using AI Agent. September 20, 2026 */
/* Added the following code for TBD.Developer using AI Agent. May 22, 2026. Code Start */
import Draggable from 'react-draggable';
/* Code end. Developer using AI Agent. May 22, 2026 */

const accentBlue = '#384AAC';

const useStyles = makeStyles(theme => ({
	bellSurface: {
		boxShadow:
			'rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px',
		borderRadius: 8,
		backgroundColor: '#fff',
		padding: 2,
		flexShrink: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'visible'
	},
	panel: {
		width: 380,
		maxWidth: '92vw',
		maxHeight: 420,
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#fff',
		borderRadius: 4,
		boxShadow:
			'rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px, rgba(0, 0, 0, 0.12) 0px 3px 14px 2px',
		pointerEvents: 'auto'
	},
	/* Added the following code for TBD.Developer using AI Agent. May 22, 2026. Code Start */
	notificationModal: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		overflow: 'visible'
	},
	notificationClickAway: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0
	},
	notificationModalContent: {
		position: 'relative',
		width: '100%',
		height: '100%',
		outline: 'none'
	},
	/* Code end. Developer using AI Agent. May 22, 2026 */
	/* Added the following code for 848.Harsha using AI Agent. May 14, 2026. Code Start */
	/**
	 * Single header row: title, search (filters loaded notifications by subject + body), action icons.
	 */
	panelHeaderRow: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1.5),
		padding: theme.spacing(1.25, 2, 1),
		flexWrap: 'nowrap'
	},
	panelTitle: {
		flexShrink: 0
	},
	/* Added the following code for TBD.Developer using AI Agent. May 22, 2026. Code Start */
	panelHeaderDragHandle: {
		cursor: 'move',
		userSelect: 'none',
		flexShrink: 0,
		marginRight: theme.spacing(1.5)
	},
	/* Code end. Developer using AI Agent. May 22, 2026 */
	searchSlot: {
		display: 'flex',
		alignItems: 'center',
		flex: 1,
		minWidth: 0,
		marginLeft: theme.spacing(0.5)
	},
	searchIconBtn: {
		padding: 6
	},
	searchFieldExpanded: {
		flex: 1,
		minWidth: 88,
		'& .MuiOutlinedInput-root': {
			fontSize: 13,
			height: 34
		},
		'& .MuiOutlinedInput-input': {
			padding: '6px 8px'
		}
	},
	panelActionsInline: {
		display: 'flex',
		gap: theme.spacing(0.5),
		flexShrink: 0,
		marginLeft: theme.spacing(1)
	},
	/* Code end. Harsha using AI Agent. May 14, 2026 */
	actionBtn: {
		padding: 4
	},
	list: {
		overflowY: 'auto',
		flex: 1,
		minHeight: 160
	},
	/* Added the following code for Istiyak using AI Agent. April 8, 2026. Code Start */
	loadMoreWrap: {
		display: 'flex',
		justifyContent: 'center',
		padding: theme.spacing(1, 1.5, 1.5)
	},
	/* Code end. Istiyak using AI Agent. April 8, 2026 */
	row: {
		padding: theme.spacing(1.25, 2),
		borderBottom: '1px solid #e8eaf0',
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1),
		cursor: 'pointer',
		'&:focus-within': {
			backgroundColor: 'rgba(56, 74, 172, 0.04)'
		}
	},
	rowUnread: {
		backgroundColor: 'rgba(56, 74, 172, 0.12)',
		borderLeft: '3px solid #384AAC'
	},
	rowMain: {
		flex: 1,
		minWidth: 0
	},
	title: {
		fontWeight: 600,
		color: accentBlue,
		fontSize: 14,
		lineHeight: 1.35
	},
	/* Added the following code for POW-787.Istiyak using AI Agent. April 6, 2026. Code Start */
	titleAlert: {
		color: '#d32f2f'
	},
	/* Code end. Istiyak using AI Agent. April 6, 2026 */
	time: {
		fontSize: 11,
		color: '#9aa3b2',
		marginTop: 4
	},
	titleUnread: {
		fontWeight: 700,
		color: '#1f2f8d'
	},
	titleRead: {
		fontWeight: 400,
		color: '#6f7b96',
		opacity: 0.95
	},
	timeUnread: {
		fontWeight: 600,
		color: '#5f6e8f'
	},
	timeRead: {
		color: '#98a4b8',
		opacity: 1
	},
	viewIconBtn: {
		padding: 6,
		flexShrink: 0
	},
	contentDialogBody: {
		fontSize: 14,
		color: '#3d4a5c',
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word'
	},
	empty: {
		padding: theme.spacing(3, 2),
		textAlign: 'center',
		color: '#9aa3b2'
	},
	badgeRoot: {
		top: 0,
		right: 0
	},
	badgeCount: {
		backgroundColor: '#ff5c5c',
		color: '#fff',
		boxShadow: '0 1px 4px rgba(255, 92, 92, 0.55)',
		fontWeight: 700,
		fontSize: 11,
		minWidth: 18,
		height: 18
	}
}));

const NOTIFICATION_CREATED_AT_FORMATS = ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601];

function parseNotificationCreatedAt(iso) {
	return moment(iso, NOTIFICATION_CREATED_AT_FORMATS, true);
}

function formatWhen(iso) {
	if (!iso) {
		return '';
	}
	const m = parseNotificationCreatedAt(iso);
	if (!m.isValid()) {
		const fallback = moment(iso);
		return fallback.isValid() ? fallback.fromNow() : String(iso);
	}
	return m.fromNow();
}

function HeaderNotifications() {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = useState(null);
	const [contentDetail, setContentDetail] = useState(null);
	/* Added the following code for TBD.Developer using AI Agent. May 22, 2026. Code Start */
	const [panelAnchor, setPanelAnchor] = useState({ top: 72, left: 0 });
	/* Code end. Developer using AI Agent. May 22, 2026 */
	const {
		notifications,
		unreadCount,
		loadError,
		hasMore,
		isFetchingPage,
		fetchNextPage,
		markOneRead,
		markAllRead,
		deleteOne,
		deleteAll
	} = useNotificationsContext();

	/* Added the following code for 848.Harsha using AI Agent. May 14, 2026. Code Start */
	/** Client-side filter on already-loaded rows; matches subject and full notification body. */
	const [searchQuery, setSearchQuery] = useState('');
	/** Search field starts as icon only; expands on click to avoid crowding the title. */
	const [searchExpanded, setSearchExpanded] = useState(false);
	const searchQueryRef = useRef('');
	const searchInputRef = useRef(null);
	searchQueryRef.current = searchQuery;
	const filteredNotifications = useMemo(() => {
		const q = searchQuery.trim().toLowerCase();
		if (!q) {
			return notifications;
		}
		return notifications.filter(n => {
			const subject = String(n.subject || '').toLowerCase();
			const body = String(n.content || '').toLowerCase();
			return subject.includes(q) || body.includes(q);
		});
	}, [notifications, searchQuery]);
	/* Code end. Harsha using AI Agent. May 14, 2026 */

	const open = Boolean(anchorEl);
	const count = unreadCount;
	const totalCount = notifications.length;

	const openContent = (n, e) => {
		if (e) {
			e.stopPropagation();
		}
		if (n && (n.notificationId || n.id)) {
			markOneRead(n.notificationId ?? n.id);
		}
		setContentDetail(n);
	};

	const onListScroll = useCallback(
		e => {
			if (!e || !e.currentTarget || isFetchingPage || !hasMore) {
				return;
			}
			const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
			if (scrollTop + clientHeight >= scrollHeight - 24) {
				fetchNextPage();
			}
		},
		[isFetchingPage, hasMore, fetchNextPage]
	);

	/* Added the following code for TBD.Developer using AI Agent. May 22, 2026. Code Start */
	const notificationPanelDragRef = useRef(null);
	const [notificationPanelDragPosition, setNotificationPanelDragPosition] = useState({ x: 0, y: 0 });
	const contentDialogDragRef = useRef(null);
	const [contentDialogDragPosition, setContentDialogDragPosition] = useState({ x: 0, y: 0 });

	useEffect(() => {
		if (!open) {
			setNotificationPanelDragPosition({ x: 0, y: 0 });
		}
	}, [open]);

	useEffect(() => {
		if (!contentDetail) {
			setContentDialogDragPosition({ x: 0, y: 0 });
		}
	}, [contentDetail]);

	const handleNotificationPanelDragStop = (e, data) => {
		setNotificationPanelDragPosition({ x: data.x, y: data.y });
	};

	const handleNotificationPanelDrag = (e, data) => {
		setNotificationPanelDragPosition({ x: data.x, y: data.y });
	};

	const handleContentDialogDragStop = (e, data) => {
		setContentDialogDragPosition({ x: data.x, y: data.y });
	};

	const handleContentDialogDrag = (e, data) => {
		setContentDialogDragPosition({ x: data.x, y: data.y });
	};

	/* Commenting the following code for TBD.Developer using AI Agent. May 22, 2026. Comment Start */
	/* function NotificationDraggablePaper(props) {
		return (
			<Draggable
				handle=".drag-handle"
				cancel=".modal-close-btn, button, input, textarea, select, .MuiIconButton-root"
				nodeRef={notificationPanelDragRef}
				position={notificationPanelDragPosition}
				onStop={handleNotificationPanelDragStop}
				enableUserSelectHack={false}
			>
				<Paper ref={notificationPanelDragRef} {...props} />
			</Draggable>
		);
	} */
	/* Commenting end. Developer using AI Agent. May 22, 2026 */

	function ContentDraggablePaper(props) {
		return (
			<Draggable
				handle=".drag-handle"
				cancel=".modal-close-btn, button, input, textarea, select, .MuiIconButton-root"
				nodeRef={contentDialogDragRef}
				position={contentDialogDragPosition}
				onDrag={handleContentDialogDrag}
				onStop={handleContentDialogDragStop}
				enableUserSelectHack={false}
			>
				<Paper ref={contentDialogDragRef} {...props} />
			</Draggable>
		);
	}

	const handleCloseNotifications = () => {
		setAnchorEl(null);
		setSearchQuery('');
		setSearchExpanded(false);
		setNotificationPanelDragPosition({ x: 0, y: 0 });
	};

	const handleOpenNotifications = e => {
		const rect = e.currentTarget.getBoundingClientRect();
		const panelWidth = 380;
		setPanelAnchor({
			top: rect.bottom + 8,
			left: Math.min(
				Math.max(8, rect.right - panelWidth),
				window.innerWidth - panelWidth - 8
			)
		});
		setNotificationPanelDragPosition({ x: 0, y: 0 });
		setAnchorEl(e.currentTarget);
	};
	/* Code end. Developer using AI Agent. May 22, 2026 */

	return (
		<>
			<div className={classes.bellSurface} title="Notifications">
				<IconButton
					size="small"
					aria-label="Notifications"
					onClick={handleOpenNotifications}
					style={{ padding: 6 }}
				>
					<Badge
						badgeContent={count}
						max={99}
						classes={{
							anchorOriginTopRightRectangle: classes.badgeRoot,
							badge: classes.badgeCount
						}}
						invisible={count === 0}
					>
						<Bell size={22} strokeWidth={1.75} color={accentBlue} />
					</Badge>
				</IconButton>
			</div>
			{/* Added the following code for TBD.Developer using AI Agent. May 22, 2026. Code Start */}
			<Modal
				open={open}
				onClose={handleCloseNotifications}
				className={classes.notificationModal}
				hideBackdrop
			>
				<div className={classes.notificationModalContent}>
					<div
						className={classes.notificationClickAway}
						onClick={handleCloseNotifications}
						aria-hidden="true"
					/>
					<Draggable
					handle=".drag-handle"
					cancel=".modal-close-btn, button, input, textarea, select, .MuiIconButton-root"
					nodeRef={notificationPanelDragRef}
					position={notificationPanelDragPosition}
					onDrag={handleNotificationPanelDrag}
					onStop={handleNotificationPanelDragStop}
					enableUserSelectHack={false}
				>
					<div
						ref={notificationPanelDragRef}
						className={classes.panel}
						style={{
							position: 'absolute',
							top: panelAnchor.top,
							left: panelAnchor.left,
							zIndex: 1
						}}
						onMouseDown={e => e.stopPropagation()}
					>
			{/* Code end. Developer using AI Agent. May 22, 2026 */}
					{/* Added the following code for 848.Harsha using AI Agent. May 14, 2026. Code Start */}
					<div className={classes.panelHeaderRow}>
						{/* Added the following code for TBD.Developer using AI Agent. May 22, 2026. Code Start */}
						<div className={`drag-handle ${classes.panelHeaderDragHandle}`}>
						{/* Code end. Developer using AI Agent. May 22, 2026 */}
						<Typography variant="subtitle1" className={classes.panelTitle} style={{ fontWeight: 700 }}>
							Notifications
						</Typography>
						{/* Added the following code for TBD.Developer using AI Agent. May 22, 2026. Code Start */}
						</div>
						{/* Code end. Developer using AI Agent. May 22, 2026 */}
						<div className={classes.searchSlot}>
							{searchExpanded ? (
								<TextField
									inputRef={searchInputRef}
									autoFocus
									className={classes.searchFieldExpanded}
									size="small"
									variant="outlined"
									placeholder="Search"
									value={searchQuery}
									onChange={e => setSearchQuery(e.target.value)}
									onClick={e => e.stopPropagation()}
									onBlur={() => {
										window.setTimeout(() => {
											if (!searchQueryRef.current.trim()) {
												setSearchExpanded(false);
											}
										}, 180);
									}}
									InputProps={{
										startAdornment: (
											<InputAdornment position="start" style={{ marginLeft: 4 }}>
												<Search size={16} color={accentBlue} strokeWidth={2} aria-hidden />
											</InputAdornment>
										)
									}}
									inputProps={{ 'aria-label': 'Search notifications' }}
								/>
							) : (
								<IconButton
									size="small"
									className={classes.searchIconBtn}
									aria-label="Open notification search"
									onClick={e => {
										e.stopPropagation();
										setSearchExpanded(true);
										window.requestAnimationFrame(() => {
											const el = searchInputRef.current;
											if (el && typeof el.focus === 'function') {
												el.focus();
											}
										});
									}}
								>
									<Search size={18} color={accentBlue} strokeWidth={2} aria-hidden />
								</IconButton>
							)}
						</div>
						<div className={classes.panelActionsInline}>
							<IconButton
								size="small"
								className={classes.actionBtn}
								aria-label="Mark all notifications as read"
								onClick={() => markAllRead()}
								disabled={totalCount === 0 || count === 0}
							>
								<CheckCheck size={16} color={accentBlue} />
							</IconButton>
							<IconButton
								size="small"
								className={classes.actionBtn}
								aria-label="Delete all notifications"
								onClick={() => deleteAll()}
								disabled={totalCount === 0}
							>
								<Trash2 size={16} color="#d32f2f" />
							</IconButton>
						</div>
					</div>
					{/* Code end. Harsha using AI Agent. May 14, 2026 */}
					<Divider />
					{loadError && (
						<Typography className={classes.empty} color="error" variant="body2">
							Could not load notifications.
						</Typography>
					)}
					{!loadError && totalCount === 0 && (
						<Typography className={classes.empty} variant="body2">
							No notifications yet.
						</Typography>
					)}
					<div className={classes.list} onScroll={onListScroll}>
						{/* Added the following code for 848.Harsha using AI Agent. May 14, 2026. Code Start */}
						{!loadError && totalCount > 0 && filteredNotifications.length === 0 && searchQuery.trim() && (
							<Typography className={classes.empty} variant="body2">
								No matching notifications.
							</Typography>
						)}
						{filteredNotifications.map(n => (
							<div
								key={String(n.notificationId ?? n.id)}
								className={`${classes.row} ${n.isRead === false ? classes.rowUnread : ''}`}
								onClick={() => markOneRead(n.notificationId ?? n.id)}
								role="button"
								tabIndex={0}
								onKeyDown={e => {
									if (e.key === 'Enter' || e.key === ' ') {
										e.preventDefault();
										markOneRead(n.notificationId ?? n.id);
									}
								}}
							>
								<div className={classes.rowMain}>
									<Typography
										className={`${classes.title} ${
											n.alert === true ||
											n.important === true ||
											String(n.alert).toLowerCase() === 'true' ||
											String(n.important).toLowerCase() === 'true'
												? classes.titleAlert
												: ''
										} ${n.isRead === true ? classes.titleRead : classes.titleUnread}`}
									>
										{n.subject || '—'}
									</Typography>
									<Typography className={`${classes.time} ${n.isRead === true ? classes.timeRead : classes.timeUnread}`}>{formatWhen(n.createdAt)}</Typography>
								</div>
								<IconButton
									size="small"
									className={classes.viewIconBtn}
									aria-label="Delete notification"
									onClick={e => {
										e.stopPropagation();
										deleteOne(n.notificationId ?? n.id);
									}}
								>
									<Trash2 size={16} strokeWidth={1.75} color="#d32f2f" />
								</IconButton>
								<IconButton
									size="small"
									className={classes.viewIconBtn}
									aria-label="View notification content"
									onClick={e => openContent(n, e)}
									disabled={!(n.content && String(n.content).trim())}
								>
									<Eye size={18} strokeWidth={1.75} color={accentBlue} />
								</IconButton>
							</div>
						))}
						{/* Code end. Harsha using AI Agent. May 14, 2026 */}
						{isFetchingPage && (
							<Typography className={classes.empty} variant="body2">
								Loading...
							</Typography>
						)}
					</div>
					{/* Added the following code for Istiyak using AI Agent. April 8, 2026. Code Start */}
					{hasMore && (
						<div className={classes.loadMoreWrap}>
							<Button
								size="small"
								variant="outlined"
								color="primary"
								onClick={() => fetchNextPage()}
								disabled={isFetchingPage}
							>
								{isFetchingPage ? 'Loading...' : 'Load more'}
							</Button>
						</div>
					)}
					{/* Code end. Istiyak using AI Agent. April 8, 2026 */}
				</div>
					</Draggable>
				</div>
			</Modal>

			<Dialog
				open={Boolean(contentDetail)}
				onClose={() => setContentDetail(null)}
				maxWidth="sm"
				fullWidth
				aria-labelledby="notification-content-title"
				/* Added the following code for TBD.Developer using AI Agent. May 22, 2026. Code Start */
				PaperComponent={ContentDraggablePaper}
				PaperProps={{
					style: {
						overflow: 'visible',
						maxHeight: 'calc(100vh - 40px)',
						display: 'flex',
						flexDirection: 'column'
					}
				}}
				/* Code end. Developer using AI Agent. May 22, 2026 */
			>
				<DialogTitle
					id="notification-content-title"
					className="drag-handle"
					style={{ cursor: 'move', userSelect: 'none' }}
				>
					{contentDetail ? contentDetail.subject || 'Notification' : ''}
				</DialogTitle>
				<DialogContent dividers style={{ overflowY: 'auto' }}>
					<Typography component="div" className={classes.contentDialogBody}>
						{contentDetail ? contentDetail.content || '' : ''}
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setContentDetail(null)} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

export default HeaderNotifications;
/* Code end. Istiyak using AI Agent. April 5, 2026 */
